import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

const FileIcon = {
  title: 'Components/Icon/File Icon',
  component: 'a1-file-icon',
  argTypes: {
    size: {
      // Rearrange the order of the options
      options: ['s', 'm'],
      control: { type: 'select' },
    },
  },
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component:
          'A list of available icons can be found [here](https://ndbx.azurewebsites.net/allianz-icons/prod/index.html).',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-file-icon';

const Template = (args: Components.A1FileIcon): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Primary: Story<Components.A1FileIcon> = Template.bind({});
Primary.args = {
  type: 'primary',
};

export const Secondary: Story<Components.A1FileIcon> = Template.bind({});
Secondary.args = {
  type: 'secondary',
};

export const Inverse: Story<Components.A1FileIcon> = Template.bind({});
Inverse.args = {
  type: 'primary',
  inverse: true,
};
Inverse.parameters = {
  backgrounds: { default: 'Inverse' },
};

export const Disabled: Story<Components.A1FileIcon> = Template.bind({});
Disabled.args = {
  type: 'primary',
  disabled: true,
};

export default FileIcon;
